import useAdminAuth from "../hooks/useAdminAuth";
import AdminSidebarMenu from "./AdminSidebarMenu";

export default function Sidebar() {
  const { admin } = useAdminAuth();

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-profile">
        <img
          src={
            admin?.image
              ? `${import.meta.env.VITE_LYRAZONE_IMAGE_URL}/uploads/users/${admin.image}`
              : "/default-avatar.png"
          }
          alt="Admin Avatar"
          className="sidebar-avatar"
        />

        <h4>{admin?.name || "Admin User"}</h4>
        <p>{admin?.email}</p>
      </div>

      <nav style={{ marginBottom: "50px" }}>
        <AdminSidebarMenu />
      </nav>
    </aside>
  );
}
